import { useState } from 'react';
import { FieldConfig } from '../types/fieldTypes';
import { validateField } from '../validations/validationRules';

interface UseValidatorProps {
  field: FieldConfig;
  value: any;
  formData?: Record<string, any>;
}

export const useValidator = ({ field, value, formData }: UseValidatorProps) => {
  const [touched, setTouched] = useState(false);
  const [validationError, setValidationError] = useState<string | null>(null);

  const handleBlur = () => {
    setTouched(true);
    if (field.validations) {
      const error = validateField(value, field.validations, formData);
      setValidationError(error);
    }
  };

  const handleValidate = (newValue: any) => {
    if (touched && field.validations) {
      const error = validateField(newValue, field.validations, formData);
      setValidationError(error);
    }
  };

  const resetValidation = () => {
    setTouched(false);
    setValidationError(null);
  };

  const forceValidate = () => {
    setTouched(true);
    if (field.validations) {
      const error = validateField(value, field.validations, formData);
      setValidationError(error);
      return error === null;
    }
    return true;
  };

  return {
    touched,
    validationError,
    handleBlur,
    handleValidate,
    resetValidation,
    forceValidate,
  };
};
